import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListParties } from '../store/slices/parties';
import { GetInvoiceslistpayments, invoicePaymentDelete } from '../store/slices/sale';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { FaFileExcel } from "react-icons/fa";
import Select from 'react-select';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import {toast } from 'react-hot-toast';
import {excelPaymentInDownload } from "../common/ExcelDownload"

const Invoicepaymentlist = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [invoicepaymentlist, setInvoicepaymentlist] = useState([]);
  const [listParties, setListParties] = useState([]);
  const [selectedParty, setSelectedParty] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
    const [selectAll, setSelectAll] = useState(false);
  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Invoice Number', field: 'invoice_number' },
    { header: 'Payment Mode', field: 'pay_mode' },
    { header: 'Transaction ID', field: 'transaction_id' },
    { header: 'Customer', field: 'party_name' },
    { header: 'Amount', field: 'amount' },
    { header: 'Payment Date', field: 'payment_date' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      actionButtons: [
        { name: 'Edit', className: 'btn-default' },
        { name: 'Delete', className: 'btn-cancel' },
      ],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const partyOptions = listParties.map((party) => ({
    value: party.id,
    label: party.ledger,
  }));

   // Load saved financial year and dates from localStorage
   const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem('selectedFinancialYear');
    
    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes('-')) {
      [startYear, endYear] = savedFinancialYear.split('-');
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear;       // Example: 2025 (for 2024-2025)
    }
  
    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem('savedFromDate') || `${startYear}-04-01`,
      toDate: localStorage.getItem('savedToDate') || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };
  
  
  const { fromDate: initialFromDate, toDate: initialToDate, minDate, maxDate, financialYear: initialFinancialYear } = loadSavedDates();
  
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [financialYear, setFinancialYear] = useState(initialFinancialYear);
  
  
  useEffect(() => {
    if (!financialYear) return;
  
    localStorage.setItem('selectedFinancialYear', financialYear);
  
    let startYear, endYear;
    if (financialYear.includes('-')) {
      [startYear, endYear] = financialYear.split('-');
    } else {
      return; // Exit if financial year is not valid
    }
  
    const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
    const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;
  
    setFromDate(savedFromDate);
    setToDate(savedToDate);
  
    if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
    if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
  }, [financialYear]);
  


  const fetchParties = async () => {
    try {
      const data = await dispatch(ListParties({ profile_id: id })).unwrap();
      setListParties(data?.data);
    } catch (error) {
      console.log('Error fetching parties:', error.message);
    }
  };

  useEffect(() => {
    fetchParties();
    fetchPaymentsList();
  }, [financialYear]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    if (item && item.id) {
      navigate(`/invoicepayment/edit/${item.id}`);
    } else {
      console.log('Item or item.id is undefined');
    }
  };



  const fetchPaymentsList = async () => {
    setIsLoading(true);
    const params = {
      profile_id: id,
      from_date: fromDate,
      to_date: toDate,
      ledger_id: selectedParty?.value || '',
    };
    // console.log(params)
    try {
      const data = await dispatch(GetInvoiceslistpayments(params)).unwrap();
      setIsLoading(false);
      setInvoicepaymentlist(data?.data);
    } catch (error) {
      setIsLoading(false);
      setInvoicepaymentlist([]);
      console.log('Error fetching invoices:', error.message);
    }
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this Invoice Payment?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(invoicePaymentDelete({ id: item.id , profile_id: id }))
        .unwrap()
        .then((data) => {
          setIsLoading(false);
          hindleReturn();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message);
        });
    } else {
      console.log('Deletion canceled');
    }
  };

  const hindleReturn = () => {
    setIsLoading(true);
    dispatch(GetInvoiceslistpayments({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setInvoicepaymentlist(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filtereditemList = invoicepaymentlist?.filter(
    (party) =>
      party?.invoice_number?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.pay_mode?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.transaction_id?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.party_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.amount?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.payment_date?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchPaymentsList();
  };

  const handleExcelDownload = () => {
    if (!invoicepaymentlist || invoicepaymentlist.length === 0) {
        alert("No data available for download.");
        return;
    }

    const selectedInvoices = selectAll && invoicepaymentlist.length > 0
        ? invoicepaymentlist.map(invoice => invoice.id)
        : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
        alert("Please select at least one PaymentsIn.");
        return;
    }

    const selectedData = invoicepaymentlist.filter(invoice => selectedInvoices.includes(invoice.id));

    if (selectedData.length === 0) {
        alert("No matching PaymentsIn found.");
        return;
    }

    try {
        excelPaymentInDownload(selectedData, "PaymentsIn.xlsx");
        toast.success("Downloading Excel file successfully!");
    } catch (error) {
        console.error("Error downloading Excel file:", error);
        alert("Failed to download the Excel file. Please try again.");
    }
};

 // Handle date changes with validation
 const handleFromDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setFromDate(newDate);
    localStorage.setItem('savedFromDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const handleToDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setToDate(newDate);
    localStorage.setItem('savedToDate', newDate);
  } else {
       toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};
const formatFinancialYear = (startDate, endDate) => {
  return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
};
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Payments</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Sale</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Payment List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default" onClick={() => navigate('/addnewinvoicepayment')}>
                Add New Payment
              </button>
                <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                 Export Excel <FaFileExcel/>
                </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>Customer</label>
                      <Select options={partyOptions} placeholder="--Select Customer--" value={selectedParty} onChange={setSelectedParty} />
                    </div>
                    <div className="col-md-3">
                      <label>From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-3">
                      <label>To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filtereditemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filtereditemList?.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows} 
                selectAll={selectAll} 
                 setSelectAll={setSelectAll} 
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Invoicepaymentlist;
